// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","443":"about"}[chunkId] || chunkId) + "." + {"177":"cb7e083b","443":"103b7724","502":"23a54a99","851":"7c4a52c7","885":"79ad5277"}[chunkId] + ".css";
};